// src/components/audio/AudioPlayer.tsx
import { Volume2, VolumeX } from 'lucide-react';
import React, { useState } from 'react';
import { HlsAudioPlayer } from '../utils/HlsAudioPlayer';
import './AudioPlayer.css';
import AudioScrubber from './AudioScrubber';
import { PlayButton } from './PlayButton';

interface AudioPlayerProps {
  hlsAudioPlayer: HlsAudioPlayer;
}

const AudioPlayer: React.FC<AudioPlayerProps> = ({ hlsAudioPlayer }) => {
  const [isMuted, setIsMuted] = useState(false);

  const handleMute = () => {
    setIsMuted(!isMuted);
    // TODO: Implement mute functionality through AudioPlayer service
  };

  return (
    <div className="flex items-center justify-between bg-gray-50 rounded-lg px-3 py-2">
      <div className="flex items-center space-x-2">
        <PlayButton hlsAudioPlayer={hlsAudioPlayer} />

        <button
          onClick={handleMute}
          className="p-1.5 hover:bg-gray-200 rounded-full transition-colors"
          aria-label={isMuted ? 'Unmute' : 'Mute'}
        >
          {isMuted ? <VolumeX size={20} /> : <Volume2 size={20} />}
        </button>
      </div>

      <AudioScrubber hlsAudioPlayer={hlsAudioPlayer}
        style={{ width: 'calc(100% - 100px)' }}
      />
    </div>
  );
};

export default AudioPlayer;